<script>
import i18n from '@/plugins/i18n';

export default {
    props: {
        text: {
            type: String,
            default: i18n.t('additionalSettings.general.delete_text'),
        },
    },

    methods: {
        onClose() {
            this.$emit('onClose');
        },

        onOk() {
            this.$emit('onOk');
        }
    }
}
</script>

<template>
    <div class="delete-item-warning" @blur="onClose()" @keyup.esc="onClose()">
        <div>
            {{ text }}
        </div>
        <div>
            <button class="cancel-delete-item-btn" @click="onClose()" @keyup.enter="onClose()">
                <i class="fa-solid fa-xmark"></i>
            </button>
            <button class="confirm-delete-item-btn" @click="onOk()" @keyup.enter="onOk()">
                <i class="fa-solid fa-check"></i>
            </button>
        </div>
    </div>
</template>

<style lang='scss' scoped>
.delete-item-warning {
    z-index: 99;
    color: rgb(70, 70, 70);
    background-color: var(--sustainfinity-faded-blue);
    position: absolute;
    left: 2em;
    top: 0;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    border-radius: .5em;
    outline: thin solid lightgray;
    box-shadow: 0 .25em .5em .1em gray;

    padding: 1em;
    min-width: 200px;

    >div {
        width: 100%;
        text-align: left;

        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;

        >button {
            padding: .5em 1em;
            margin: 1em .3em 0 .3em;
            margin-bottom: 0;
            border-radius: .25em;
            border: 0;
            outline: 0;
            color: white;
            text-align: center !important;

            &:focus {
                outline: thin solid gray !important;
            }

            &:active {
                scale: .95;
            }
        }

        >.cancel-delete-item-btn {
            background-color: var(--invalid-input);

            &:hover {
                background-color: var(--invalid-input--hover);
            }
        }

        >.confirm-delete-item-btn {
            background-color: var(--sustainfinity-green);

            &:hover {
                background-color: var(--sustainfinity-green--hover);
            }
        }
    }
}
</style>